// Copyright 2005-2010 Jim Radford <radford@blackbean.org>, David Caldwell <david@porkrind.org>

var plat = require('./platform');
var Prefs = require('./prefs');
var dom = require('./dom'), on_load=dom.on_load, on_unload=dom.on_unload, timeout=dom.timeout, cancel_timeout=dom.cancel_timeout, URL=dom.URL, Deferral=dom.Deferral;
var lib = require('./lib'), merge=lib.merge, merge_into=lib.merge_into, map=lib.map, rand=lib.rand, add=lib.add;
var debug = require('./debug'), maybe_try=debug.maybe_try, maybe_try_wrap=debug.maybe_try_wrap, try_report=debug.try_report, report_error=debug.report_error;
var seed_game = require('./seed_game');
var options = require('./options'), get_options=options.get_options;
var ajax = require('./ajax'), makeurl=ajax.makeurl, makeurlparams=ajax.makeurlparams;
var prnt = require('./print'), print=prnt.print, sprintf=prnt.sprintf, dprintf=prnt.dprintf;
var Alert = require('./alert'), new_text_alert=Alert.new_text_alert;

var joker = 0, ace = 1, jack = 11, queen = 12, king = 13, foundation = 14;
var clubs = 0, diamonds = 1, hearts = 2, spades = 3;
var suit_string = ['C','D','H','S'];
var rank_string = ['R','A','2','3','4','5','6','7','8','9','10','J','Q','K','F'];
var up=1,down=0;

function card(rank, suit, index, face, deck, game) {
    this.rank   = rank;
    this.suit   = suit;
    this.index  = index;
    this.face   = face;
    this.deck   = deck;
    this.red    = suit == diamonds || suit == hearts;
    this.black  = suit == clubs    || suit == spades;
    this.string = (typeof this.rank == "number" ? this.rank==joker ? 'J'                          : rank_string[this.rank] : this.rank)
                + (typeof this.suit == "number" ? this.rank==joker ? ['1','2','3','4'][this.suit] : suit_string[this.suit] : "");
    this.ui     = new game.piles_ui.card_ui(this, game);
}
card.prototype.toString = function() { return this.face == down ? this.string.toLowerCase() : this.string; }
card.prototype.toJSON   = function() { return this.toString(); }
card.prototype.turn_face = function(face) { this.face = face; return this }

function in_color_order(card1, card2) {
    return card1.rank+1 == card2.rank && card1.red == card2.red && card1.face == up && card2.face == up;
}

function in_color_wrap_order(card1, card2) {
    return (card1.rank == king && card2.rank == ace ||
            card1.rank+1 == card2.rank) && card1.red == card2.red && card1.face == up && card2.face == up;
}

function in_off_color_order(card1, card2) {
    return card1.rank+1 == card2.rank && card1.red != card2.red && card1.face == up && card2.face == up;
}

function in_off_color_wrap_order(card1, card2) {
    return (card1.rank == king && card2.rank == ace ||
            card1.rank+1 == card2.rank) && card1.red != card2.red && card1.face == up && card2.face == up;
}

function in_suit_order(card1, card2) {
    return card1.rank+1 == card2.rank && card1.suit == card2.suit && card1.face == up && card2.face == up;
}

function in_suit_wrap_order(card1, card2) {
    return (card1.rank == king && card2.rank == ace ||
            card1.rank+1 == card2.rank) && card1.suit == card2.suit && card1.face == up && card2.face == up;
}

function in_different_suit_order(card1, card2) {
    return card1.rank+1 == card2.rank && card1.suit != card2.suit && card1.face == up && card2.face == up;
}

function in_numeric_order(card1, card2) {
    return card1.rank+1 == card2.rank && card1.face == up && card2.face == up;
}

function in_numeric_wrap_order(card1, card2) {
    return (card1.rank == king && card2.rank == ace ||
            card1.rank+1 == card2.rank) && card1.face == up && card2.face == up;
}

function in_order_by(f, cards, start) {
    for (var i=start||0; i<cards.length-1; i++)
        if (!f(cards[i+1],cards[i]))
            return false;
    return cards[i].face == up; // this is compatability in the n == 1 case with all the '== up' checks in in_*_order()
}

function count_top_order_by(f, cards, start) {
    if (start == undefined) start = cards.length-1; // our stupid babel doesn't have ??
    var count=0;
    for (var i=start; i>=0; i--, count++)
        if (i<start && !f(cards[i+1], cards[i]))
            break;
    return count;
}

function score_run(n) {
    var sum = n => n*(n+1)/2;
    return Math.floor(sum(n)*13/sum(13));
}

function score_order_by(f, cards, start) {
    var count=0, run=0;
    for (var i=start||0; i<cards.length-1; i++)
        if (f(cards[i+1],cards[i])) {
            run += run ? 1 : 2;
        } else {
            count += score_run(run);
            run = 0;
        }
    return count + score_run(run);
}

// This is only called once, ever (unless you have two decks)
function init_deck(jokers, game) {
    var cards = [], deck = {};
    for (var i=0,s=clubs; s<=spades; s++)
        for (var n=1; n<=king; n++,i++)
            cards[i] = new card(n,s,i,down,deck,game);
    for (var s=0; s<jokers; s++,i++)
        cards[i] = new card(joker,s,i,down,deck,game);
    return cards;
}


function shuffle(deck, times) {
    if (times == undefined)
        times = 7;
    for (var i=0; i<times; i++)
        for (var a in deck) {
            var b = rand() % deck.length;
            var tmp = deck[a];
            deck[a] = deck[b];
            deck[b] = tmp;
        }
    return deck;
}

function translate(a, b) {
    return {x : a.x + b.x, y: a.y + b.y };
}

function point_distance(a, b) {
    return Math.sqrt((a.x-b.x)*(a.x-b.x) + (a.y-b.y)*(a.y-b.y));
}

var base64 = {
    enc:"0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ!@",
    to: function(n) {
        return 0 <= n && n < base64.enc.length ? base64.enc.slice(n,n+1) : "?";
    },
    from: function(c) {
        return base64.enc.indexOf(c);
    }
}

function dup(object) {
    return merge_into({}, object);
}

class pile {
  constructor(div,game,empty) {
    this.game = game;
    this.name = div;
    this.pile = [];
    this.ui = new game.piles_ui.pile_ui(div, this);
    if (!this.ui) throw("No ui-cookie found for "+div);
    this.origin ??= { x:0, y:0 };
    if (this.xoffset       == undefined)  this.xoffset = 0;
    if (this.yoffset       == undefined)  this.yoffset = 30/131;
    if (this.accept_stacks == undefined)  this.accept_stacks = false;
    if (this.drag_stacks   == undefined)  this.drag_stacks = true;
    if (empty ?? true) {
        this.empty = new card("empty-pile", undefined, undefined, up, null, game);
        this.redraw_empty();
    }
    this.ui.set_drag_start_handler(this.drag_start = maybe_try_wrap(this, function(e) {
        if ("button" in e && e.button != plat.left_button) return; // only deal with left click for now.
        this.game.stabilize_state();
        var drag = { i: undefined, handle: { x:0, y:0 }, start: { x: e.targetX, y: e.targetY, time: Date.now() }, animations: [] };
        drag.anim_callback = function() {
            let callbacks = {};
            drag.animations.push(new Promise((resolve, reject) => callbacks = { resolve, reject }));
            return callbacks.resolve;
        };
        drag.animations_done = () => Promise.all(drag.animations);

        this.game.add_event_history({ pile:this.name, kind: "onmousedown", event: dup(e), drag: dup(drag) });

        if (this.onclick) if (this.onclick(e) !== false) return false;
        if (!this.pile.length) return;
        if (this.game.is_paused()) return false;

        for (var i=this.top_index(); i>=0; i--) {
            var c = this.coords(i);
            if (e.targetX >= c.x && e.targetX < c.x + 1 &&
                e.targetY >= c.y && e.targetY < c.y + 1) {
                drag.i = i;
                drag.handle.x = e.targetX - c.x;
                drag.handle.y = e.targetY - c.y;
                break;
            }
        }
        if (drag.i == undefined) return false;

        drag.state = game.get_state();

        // Keep track of what is initially visible to the player so we don't go too crazy with fpreliminaries.
        drag.fvisible = this.pile.map(c => c.face == up);

        drag.fpreliminaries = [];
        while (!this.can_drag(drag.i)) {
            var fpreliminary = undefined;
            for (var i = drag.i+1; i<this.pile.length; i++) {
                if (this.can_drag(i) && drag.fvisible[i]) {
                    var n = this.drag_stacks ? this.pile.length-i : 1;
                    var destinations = game.find_target_piles(this, i, n);
                    if (destinations.length) {
                        fpreliminary = this._move_to_pile(i, n, destinations[0]);
                        break;
                    }
                }
            }
            if (!fpreliminary) {
                game.set_state(drag.state, true);
                return false;
            }
            drag.fpreliminaries.push(fpreliminary);
        }

        this.game.drag = drag; // Ok, we're dragging something now.... Maybe
        drag.card = this.pile.slice(drag.i, this.drag_stacks ? this.pile.length : drag.i+1);
        for (var i in drag.card)
            drag.card[i].dragging = true; // stops certain animations from happening. We want to control this card.

        drag.destinations = [];
        {
            var state = game.get_state();
            for (var gpi in game.piles) {
                var p = game.piles[gpi];
                if (p == this)
                    continue;
                var tpreliminaries = [];
                // Keep track of what is initially visible to the player so we don't go too crazy with
                // tpreliminaries. We can't check the card face later since we mess with the state and so it's
                // _always_ "up".
                var tvisible = p.pile.map(c => c.face == up);
                do {
                    var affinity;
                    if ((p.pile.length == 0 || tvisible[p.top_index()]) && // Don't play onto the top card if wasn't initially visible.
                        (affinity = game.move_affinity(this, drag.i, p, p.pile.length, drag.card.length))) {
                        var destination = { to: p,    tstart: p.pile.length, tpreliminaries: tpreliminaries.slice(0), subsequents: [],
                                            from: this, fstart: drag.i, n: drag.card.length, removed: drag.card, affinity: affinity };
                        {
                            var save = game.get_state();
                            // do the move so we can look for subsequent moves (sht.html?game=26999559 move the KC to the QC column)
                            this._move_to_pile(drag.i, drag.card.length, p); // should be game.do_move([destination]), but it doesn't split the move?

                            do {
                                var subsequent = undefined, affinity = 0, preliminary = undefined;
                            subsequent:
                                for (var tp=0; tp<destination.tpreliminaries.length; tp++) {
                                    for (var tpi=destination.tpreliminaries[tp].length-1; tpi>=0; tpi--) {
                                        var pre = destination.tpreliminaries[tp][tpi], new_affinity;
                                        if (pre.n == pre.to.pile.length - pre.tstart &&
                                            pre.to.can_drag(pre.tstart) &&
                                            affinity < (new_affinity = game.move_affinity(pre.to, pre.tstart, p, p.pile.length, pre.n)))
                                        {
                                            affinity = new_affinity;
                                            preliminary = pre;
                                        }
                                    }
                                }
                                if (preliminary) {
                                    subsequent = preliminary.to._move_to_pile(preliminary.tstart, preliminary.n, p);
                                    subsequent[0].fanimate = preliminary.tanimate = false; // skip the pre move and just animate the subsequent
                                    destination.subsequents.push(subsequent);
                                }
                            } while(subsequent);

                            game.set_state(save, true);
                        }
                        drag.destinations.push(destination);
                    }

                    // try moving the something off the top as a preliminary move
                    var tpreliminary = undefined;
                    for (var pi = 0; pi < p.pile.length; pi++) {
                        if (tvisible[pi] && p.can_drag(pi)) { // Don't try to move it if it wasn't initially visible.
                            var n = p.drag_stacks ? p.pile.length-pi : 1;
                            var destinations = game.find_target_piles(p, pi, n, this);
                            if (destinations.length) {
                                var save = game.get_state();
                                tpreliminary = p._move_to_pile(pi, n, destinations[0]);
                                if (this.can_drag(drag.i)) // The preliminary might invalidate our current move (drag_max_given_free()).
                                    tpreliminaries.push(tpreliminary);
                                else {
                                    game.set_state(save, true);
                                    tpreliminary = undefined;
                                }
                                break;
                            }
                        }
                    }
                } while (tpreliminary);
                game.set_state(state, true);
            }
        }
        drag.destinations.sort(function(a,b) { return (!b.tpreliminaries.length - !a.tpreliminaries.length) // avoid tpreliminaries
                                                   || (b.affinity - a.affinity) });

        //print("--\n"); for (var i in drag.destinations) print_structure(drag.destinations[i], "d[" + i + "]");

        this.game.allow_pause(0); // disable pause for the drag

        this.ui.set_drag_handler(function(e) {
          maybe_try(function() {
            if (!drag.ged) {
                for (var i in drag.fpreliminaries)
                    this.game.animate_move(drag.fpreliminaries[i], drag.anim_callback());
                drag.ged = true;
            }

            this.game.add_event_history({ pile:this.name, kind: "onmousemove", event: dup(e), drag: dup(drag) });
            for (var i=0; i<drag.card.length; i++)
                drag.card[i].ui.draw(this.ui,{ x: e.targetX - drag.handle.x + this.xoff()*i,
                                               y: e.targetY - drag.handle.y + this.yoff()*i,
                                               z: i }, 100);

            // This is really slow :-(
            // Highlight the best pile
            var m = this.find_best_move(drag.destinations, { x: e.targetX - drag.handle.x, y: e.targetY - drag.handle.y });

            if (!m || drag.destination != undefined && drag.destination != m) {
                if (drag.destination) {
                    if (drag.destination.prestate)
                        this.game.set_state(drag.destination.prestate, true);
                    for (var i = drag.destination.subsequents.length-1; i >= 0; i--) // undo previously displayed moves
                        this.game.animate_move(this.reverse_move(drag.destination.subsequents[i]), drag.anim_callback());
                    for (var i = drag.destination.tpreliminaries.length-1; i >= 0; i--) // undo previously displayed moves
                        this.game.animate_move(this.reverse_move(drag.destination.tpreliminaries[i]), drag.anim_callback());
                    delete drag.destination.prestate;
                    delete drag.destination.move;
                    delete drag.destination;
                }
                if (drag.hover_timeout)
                    drag.hover_timeout = cancel_timeout(drag.hover_timeout);
            }
            if (m && (drag.destination ? drag.destination != m : !drag.hover_timeout)) {
                if (drag.hover_timeout)
                    drag.hover_timeout = cancel_timeout(drag.hover_timeout);
                drag.hover_timeout = timeout(1000, function() {
                    drag.destination.prestate = game.get_state();
                    for (var i in m.tpreliminaries) // draw the current moves
                        this.game.animate_move(this.game.do_move(m.tpreliminaries[i]), drag.anim_callback());
                    drag.destination.move = this._move_to_pile(drag.i, drag.card.length, m.to);
                    for (var i in m.subsequents) // draw the current moves
                        this.game.animate_move(this.game.do_move(m.subsequents[i]), drag.anim_callback(), 100000);
                    delete drag.hover_timeout;
                }.bind(this));
                drag.destination = m;
            }

            // Hilight the top pile.
            if (m)
                this.game.highlight.highlight(m.to, m.tstart)
            else
                this.game.highlight.erase();

          }.bind(this), function(e) {
              this.game.report_error("onmousemove()", e);
          }.bind(this));

          return false;
        }.bind(this));
        this.ui.set_drag_end_handler(this.game.drag.end = function(e) {
            if ("button" in e && e.button != plat.left_button) return; // only deal with left click for now.
            var m;

          maybe_try(function() {
            this.game.add_event_history({ pile:this.name, kind: "onmouseup", event: dup(e), drag: dup(drag) });
            this.game.allow_pause(1); // enable pause now that the drag has finished

            if (e.cancel_drag)
                m = void 0;
            else if (!drag.ged ||  // single click is the new double_click!
                     Date.now() - drag.start.time < 250/*ms*/ && point_distance(drag.start, {x:e.targetX, y: e.targetY}) < game.ui.cardset_pixels(50)) // Probably meant this as a single click
                m = drag.destinations[0]; // This was sorted so the best is first.
            else
                m = this.find_best_move(drag.destinations, { x: e.targetX - drag.handle.x, y: e.targetY - drag.handle.y });

            if (drag.hover_timeout) {
               drag.hover_timeout = cancel_timeout(drag.hover_timeout);
               delete drag.destination; // hasn't animated yet, so don't pretend we have
            }

            this.game.highlight.erase();
            delete this.game.drag; // do this before move_to_pile can cancel the drag

            for (var i in drag.card)
                delete drag.card[i].dragging;

            drag.m = m;
            if (m) {
                game.push_state(drag.state);
                if (!drag.ged)
                    for (var i in drag.fpreliminaries)
                        this.game.animate_move(drag.fpreliminaries[i], drag.anim_callback());
                if (drag.destination != m) { // only need to move stuff if we didn't commit earlier during a hover_timeout
                    for (var i in m.tpreliminaries) { // do and draw the current moves
                        // this should be m.tpreliminaries[i].do() or move_to_pile(), but we have the *result* of _move_to_pile, not the input!
                        this.game.animate_move(this.game.do_move(m.tpreliminaries[i]), drag.anim_callback());
                    }
                    this.move_to_pile(drag.i, drag.card.length, m.to, drag.anim_callback());
                    for (var i in m.subsequents)
                        // this should be m.subsequents[i].do() or move_to_pile(), but we have the *result* of _move_to_pile, not the input!
                        this.game.animate_move(this.game.do_move(m.subsequents[i]), drag.anim_callback());
                } else
                    this.game.animate_move(drag.destination.move, drag.anim_callback());
            } else {
                this.game.animate_move([{ from:this, to:this, tstart:drag.i, n:drag.card.length, removed:drag.card }], drag.anim_callback());
                if (drag.state) game.set_state(drag.state, true); // put the game state back before we animate so cards get unflipped if nec
                for (i = drag.fpreliminaries.length-1; i >= 0; i--)
                    this.game.animate_move(this.reverse_move(drag.fpreliminaries[i]), drag.anim_callback());
            }
          }.bind(this), function(e) {
              this.game.report_error("onmouseup()", e, { m:m, drag: drag, event_history: this.game.event_history });
          }.bind(this));

          this.ui.drag_complete();
        }.bind(this));
        return false;
    }, function(e) {
        delete this.game.drag; // Don't leave this lying around
        this.game.report_error("onmousedown()", e);
        return false;
    }));
    this.pilenum = this.game.piles.length;
    this.game.piles.push(this);
  }

  async fake_click(index) {
    var c = this.coords(index);
    var fake_event = { targetX:c.x, targetY:c.y };
    this.drag_start(fake_event);
    let drag = this.game.drag;
    if (!drag) // The drag_start might have decided nothing was movable.
        return false;
    drag.end(fake_event);
    await drag.animations_done();
    return drag.m;
  }

  toString() { return this.name + ": " + this.pile; }
  toJSON() { var o = {}; o[this.name] = this.pile; return o; }

  update_stats() {
    this.game.stats.set(this.name,        this.pile.length);
    this.game.stats.max(this.name+"_max", this.pile.length);
    this.game.stats.min(this.name+"_min", this.pile.length);
  }

  pop() {
    return this.splice(this.top_index(), 1)[0];
  }

  push(card) {
    return this.splice(this.pile.length, 0, card);
  }

  shift() {
    return this.splice(0, 1)[0];
  }

  unshift(card) {
    return this.splice(0, 0, card);
  }

  top() {
    if (!this.pile.length) alert("there is no top of an empty pile");
    return this.pile[this.top_index()];
  }

  top_index() {
    return this.pile.length-1;
  }

  xoff() { return this.xoffset; }
  yoff() { return this.yoffset; }

  coords(_index, _pile_length) {
    var index = +_index, pl = _pile_length || this.pile.length, dx = this.xoff(), dy = this.yoff();
    return { x: this.origin.x + index * dx,
             y: this.origin.y + index * dy,
             z: index + (this.zoffset||0) };
  }

  // coords(_index, _pile_length) {
  //     var index = +_index, pl = _pile_length || this.pile.length;
  //     if (index <= 0) return { x:0, y:0 };
  //     var l = this.coords(index-1, pl);
  //     return { x: Math.max(0, l.x + Math.max(Math.min(6,this.xoff()), this.xoff() - 2*(pl - index))),
  //              y: Math.max(0, l.y + Math.max(Math.min(6,this.yoff()), this.yoff() - 2*(pl - index))),
  //              z: index + (this.zoffset||0) };
  // }
  // coords(_index, _pile_length) {
  //     var index = +_index, pl = _pile_length || this.pile.length;
  //     var c = { "x": (pl > 0 ? Math.max(0, index*(this.xoff()+1)-((index+1)*index)/2 - index*(pl-index-1)) : index*this.xoff()),
  //               "y": (pl > 0 ? Math.max(0, index*(this.yoff()+1)-((index+1)*index)/2 - index*(pl-index-1)) : index*this.yoff()),
  //               "z": index + (this.zoffset||0) };
  //     return c;
  // }


  redraw_empty() {
    if (this.empty)
        this.empty.ui.draw(this.ui, { ...this.coords(0), z:-2 });
  }

  redraw() {
    this.redraw_empty();
    for (var c=0; c<this.pile.length; c++)
        this.pile[c].ui.draw(this.ui, this.coords(c));
  }

  fixup_coords() {
    for (var c=0; c<this.pile.length; c++) {
        var pc = this.coords(c),
            cc = this.pile[c].ui.coords;
        if (!this.pile[c].dragging && (cc.x != pc.x || cc.y != pc.y || this.pile[c].pile_ui != this.ui))
            this.pile[c].ui.animate_to(this, c);
    }
  }

  update() {
    this.game.stats.set(this.name, this.pile.length);
    //print("Updating pile "+this.name+", width="+card_width+"\n");
    for (var c=0; c<this.pile.length; c++) {
        this.pile[c].ui.update_face();
        this.pile[c].ui.set_cursor(this.can_drag(c) ? "move" : "default");
    }
    var i = this.overlap ? 0 : Math.max(this.pile.length == 0 ? 0: this.top_index(), (this.maxstack||1)-1);
    var c0 = this.coords(0), ci = this.coords(i);
    this.ui.set_size(1 + Math.abs(ci.x - c0.x), 1 + Math.abs(ci.y - c0.y));
    this.ui.update();
  }

  splice(start, n/*, card1, card12, ...*/) {
    var removed = this.pile.splice.apply(this.pile, arguments);
    this.update_stats();
    return removed;
  };

  splice_and_turn_over(start, n/*, card1, card12, ...*/) {
    var removed = pile.prototype.splice.apply(this, arguments);
    if (this.pile.length && arguments.length <= 2/*don't turn over when adding cards*/)
        this.top().face = up;
    return removed;
  }

  splice_and_turn_under(start, n/*, card1, card12, ...*/) {
    if (this.pile.length && arguments.length > 2/*don't turn over when removing cards*/)
        this.top().face = down;
    return pile.prototype.splice_and_turn_over.apply(this, arguments);
  }
  move_char() {
    return base64.to(this.pilenum);
  }

  reverse_move(move) {
    return map(function(m) { return { from:m.to, to:m.from, n:m.n, fstart:m.tstart, tstart:m.fstart,
                                      removed:m.removed, fanimate:m.tanimate, tanimate:m.fanimate    } }, move);
  }

  _move_to_pile(start, n, to) {
    var m = to.split_move ? to.split_move(start, n, this) : [{from:this,to:to,fstart:start,n:n}];
    if (this.append_moves) m.push.apply(m, this.append_moves(start, n));
    this.game.do_move(m);
    return m;
  }

  move_to_pile(start, n, to, callback) {
    this.game.stabilize_state();
    this.game.animate_move(this._move_to_pile(start, n, to), callback);
    this.game.end_of_move();
  }

// This should be overridden.
// If pile.accept_stacks is true then card is an array of cards, otherwise it is a single card.
// pile.accept() should return a priority that tells how "desirable" this partical move would be.
// This is used for when the user double clicks a pile. The highest priority pile will become the
// final destination. If there are multiple piles with the same priority then on will be picked
// randomly (whatever sort happens to return first).
  accept  (card)  { return 1; }

// This should be overridden.
// This gets passed the index of a card in the pile. It should return whether the user is allowed
// to drag that card (and all the cards above it if it isn't the top card in the pile).
  can_drag(index) { return true; } // Should be overridden!

// Finds all piles that intersect a given card. Returns pile with largest area of intersection.
  find_best_move(inm, coords) {
    var m = [];
    var p = translate(this.ui.coords, coords);
    for (var i in inm) {
        var p_i = translate(inm[i].to.ui.coords, inm[i].to.coords(inm[i].tstart));
        var dx = Math.abs(p.x - p_i.x), dy = Math.abs(p.y - p_i.y);
        if (dx < 1 && dy < 1)
            m.push({ area: dx * dy, move: inm[i] });
    }
    m.sort(function(a,b) { return a.area - b.area });
    // pick the pile with highest overlapping area
    if (m.length) return m[0].move;
  }
}

function find(array, card) {
    for (var i in array)
        if (array[i] == card)
           return i;
}

function drag_max_given_free(piles, dest)
{
    var drag_max = 1;
    for (var i in piles)
        if (piles[i].pile.length == 0 && piles[i] !== dest)
            drag_max *= 2;
    return drag_max;
}

function empty_pile_count(piles) {
    var free = 0;
    for (var i in piles)
        if (piles[i].pile.length == 0)
            free++;
    return free;
}

class pile_game extends seed_game {
  pile_game_init(name, piles_ui) {
    this.seed_game_init(name,piles_ui);

    if (!this.options) this.init_options(name);

    this.piles = [];

    this.piles_ui = piles_ui; // so pile() constructor can get it
    this.ui = new piles_ui.pile_game_ui(this);

    this.fresh_deck = [];
    for(var i=0; i<8; i++) this.fresh_deck.push(init_deck(0, this));

    this.highlight = new card("highlight",undefined,undefined,up,null,this);
    this.highlight.highlight = function(pile, n) {
        this.ui.draw(pile.ui, pile.coords(n), 0.5);
    };
    this.highlight.erase = function() { this.ui.erase(); }
    on_unload(() => this.save_game());
  }

  init_options(name) {
    let variants = this.constructor.variants ?? this.variants ?? {};
    this.options = get_options(this.valid_options || {}, variants[name]);
  }

  new_game(seed) {
    super.new_game(seed);

    // remove all cards from existing piles
    for (var p in this.piles)
        this.piles[p].pile.splice(0,this.piles[p].pile.length);
    for (var i in this.fresh_deck)
        for (var c in this.fresh_deck[i])
           this.fresh_deck[i][c].face = down;

    // Actually start
    this.moves = [];
    this.state = {};
    this.start_stats();
    this.stats.set("moves", "");
    for (var i in this.options)
        this.stats.set("options_"+i, this.options[i]);
    var decks = []; for (var i=0; i<(this.decks||1); i++) decks.push.apply(decks, this.fresh_deck[i]);
    this.deal(shuffle(decks, this.seed == -1 ? 0 : 7));
    this.ui.backs_visible(this.backs_visible());
    this.redraw();
    for (var p in this.piles)
        this.schedule_update(this.piles[p]);
    var me = this;
    //on_unload(function() { me.stats.done(); });
  }

  save_game() {
    if (this.ended) return; // Don't save games that have ended!
    if (this.moves.length == 0) return; // Don't save brand new games
    let save_state = JSON.stringify({
        seed: this.seed,
        moves: this.moves.join(""),
        stats: this.stats.save(),
    });
    localStorage.setItem(`saved-game_${this.name}`, save_state);
  }

  restore_game() {
    let saved_seed = this.seed;
    let saved_game = try_report(() => localStorage.getItem(`saved-game_${this.name}`), "restore_game()");
    if (!saved_game) return; // nothing to restore
    try_report(() => localStorage.removeItem(`saved-game_${this.name}`), "restore_game()");
    try {
        let save_state = JSON.parse(saved_game);
        this.stats.cancel(); // don't send off a score for a zero move game that existed for less than a millisecond
        this.new_game(save_state.seed);
        this.replay(save_state.moves, true)
            .then(() => {
                this.stats.restore(save_state.stats);
                this.ui.game_restored();
            });
    } catch(e) {
        new_text_alert("There was a saved game but I was unable to restore it. Sorry.");
        report_error("restore_game", e, { saved_game });
        this.new_game(saved_seed);
    }
  }

  backs_visible() {
    for (var p in this.piles)
        for (var c in this.piles[p].pile)
            if (this.piles[p].pile[c].face === down)
                return true;
  }

  set_state(old, noupdate) {
        super.set_state(old);
        this.moves = old.moves.slice(0);
        this.state = merge({}, old.state);
        this.stats.set("moves", this.moves.join(""));
        for (var p in old.pile) {
            this.piles[p].pile = [];
            for (var c in old.pile[p]) {
                this.piles[p].pile[c]      = old.pile[p][c].card;
                this.piles[p].pile[c].face = old.pile[p][c].face;
            }
	    this.piles[p].update_stats();
        }
        if (!noupdate)
            for (var p in this.piles)
                this.schedule_update(this.piles[p]);
  }

  get_state() {
    var old = super.get_state();
    old.moves = this.moves.slice(0);
    old.pile = [];
    old.state = merge({}, this.state);
    for (var p in this.piles) {
      try_report(function() { // TEMP: remove try/catch after debugging http://greenfelt.net/errors?e=e278267b26
        old.pile[p] = [];
        for (var c in this.piles[p].pile)
          try_report(function() { // TEMP: remove try/catch after debugging http://greenfelt.net/errors?e=87e32e2440
            old.pile[p][c] = { card: this.piles[p].pile[c], 
                               face: this.piles[p].pile[c].face };
          }.bind(this), "get_state()", { p:p, c:c, "this.piles[p].pile[c]": String(this.piles[p].pile[c]) });
      }.bind(this), "get_state() outer loop", { p:p, "this.piles[p]": String(this.piles[p]) });
    }
    return old;
  }

  best_pile(from_pile, fstart, piles) {
    var dest = [];
    for (var p in piles)
        dest.push({ index:p, score:this.move_affinity(from_pile, fstart, piles[p], piles[p].pile.length, 1) });
    dest.sort(function(a,b) { return b.score - a.score });
    return dest[0].score ? dest[0].index : undefined;
  }

  complete_generic(good, from) {
    var any = 0;
    var step = (cards) => {
        if (!cards) return;
        if (this.drag) return; // move_to_pile will cancel (via stabilize_state) any drag which might change game state out from under us
        var testpile = (from, cards) => {
            for (var c=from.top_index(); c>=0 && (!from.drag_stacks || c==from.top_index()); c--) {
                var g;
                if ((g = this.best_pile(from, c, good)) != undefined) {
                    from.move_to_pile(c, 1, good[g], () => step(1));
                    cards--; any++;
                    timeout(137, () => step(cards));
                    return cards;
                }
            }
            return cards;
        };
        for (var f in from)
            for (var p in from[f])
                if (from[f][p].pile.length)
                    if (!(cards = testpile(from[f][p], cards)))
                        return;
    };
    step(3);
    return any;
  }

  count_cards_in(piles) {
    return add(map(function(p) { return p.pile.length }, piles));
  }

  create_deck(deck, play, cards, redeal) {
    if (redeal == undefined || redeal === true) redeal = Infinity;
    if (redeal === false) redeal = 0;
    this.ui.deck_play = deck.onclick = function() {
        if (deck.pile.length == 0 && (play.pile.length <= cards || deck.redeals() >= redeal))
            return false; // pointless
        this.push_state();
        deck.turn();
        this.moves.push("*"+deck.move_char());
        this.end_of_move();
    }.bind(this);
    deck.redeals = () => this.state.redeals = this.state.redeals || 0;
    deck.turn = function() {
        if (deck.pile.length == 0) { // already checked if we are allowed to in deck_play()
            this.state.redeals++;
            while (play.pile.length) {
                var card = play.pop();
                card.face = down;
                deck.push(card);
                card.ui.cancel_animation(); // The card might still be flying around from another very recent click (or an undo or something)
            }
            this.stats.inc("deck flipped");
            deck.redraw();
            play.redraw();
            this.schedule_update(deck);
        }
        for (var i=0; i<cards && deck.pile.length; i++) {
            // Consider converting this to animate_move()--requires thinking about moves and the '*' move, especially flipping the deck (above)
            var card = deck.pop();
            card.face = up;
            play.push(card);
        }
        deck.game.schedule_update(play); // For N-turn games we may need to update because coords() just changed. Only noticeable when there's less than N cards in the deck
        deck.ui.update(); // This is so the card count hover title thing updates.
    }.bind(this);

    deck.accept = function(card) { return false; }
    deck.can_drag = function(index) { return false; }
    deck.xoffset = 1/90;
    deck.yoffset = 1/131;
    deck.maxstack = 52 * (this.decks||1);
    deck.title = true;
    deck.icon = new card("redeal", void 0, 0, up, null, this);
    deck.update_redeal = () => {
        if (deck.redeals() >= redeal)
            deck.icon.ui.erase();
        else
            deck.icon.ui.draw(deck.ui, { x:0, y:0, z:-1 });
    }
    deck.update = () => {
        pile.prototype.update.apply(deck);
        deck.update_redeal();
    }
    if (cards == 1 && plat.webkit) // only when we show only the top card is this optimization possible
        play.splice = play.splice_and_turn_under;
    play.accept = function(card) { return false; }
    play.can_drag = function(index) { return index == this.top_index(); }
    play.xoffset = 30/90;
    play.yoffset = 0;
    play.title = true;
    play.maxstack = cards;
    play.coords = function(_index, _pile_length) {
        var index = +_index, pl = _pile_length || this.pile.length;
        var c = Math.max(0, cards+index-Math.max(cards,this.pile.length));
        return { x: c*this.xoff(), y: c*this.yoff(), z: index };
    }
  }

  extra_error(extra) {
      return super.extra_error(merge(extra || {},
                                     { moves   : this.stats.current && this.stats.current.moves,
                                       replay  : this.replay_url() }));
  };

  event_history = [];
  add_event_history(entry) {
    this.event_history.push(merge({ timestamp:Date.now() },
                                  entry));
    if (this.event_history.length > 5) this.event_history.shift();
  }

  stabilize_state () {
    super.stabilize_state();
    if (this.drag)
        this.drag.end({ cancel_drag: true });
  }

// Override this to convert moves in older games to their modern equivalents.
  fix_replay_move(r) { return r };

// Moves:
// <from><to>
// <from>:<number-of-cards-from-top><to>
// <from>-<start><length><to>
// *<pile>  call piles "onclick" handler
  static  RESTORING = Symbol("RESTORING");
  replay(replay, restoring, callback) {
    var step = function(resolve, reject) {
        if (replay == "") { dprintf("Done\n"); return resolve(this.score()); }
        replay = this.fix_replay_move(replay);
        var m, from , start, n, to, rest, click;
        if      (m = replay.match(/^(\*(.))(.*)$/))         { click= m[2];                              rest=m[3]; }
        else if (m = replay.match(/^((.)-(.)(.)(.))(.*)$/)) { from = m[2]; start=m[3]; n=m[4]; to=m[5]; rest=m[6]; }
        else if (m = replay.match(/^((.):(.)(.))(.*)$/))    { from = m[2];             n=m[3]; to=m[4]; rest=m[5]; }
        else if (m = replay.match(/^((.)([^-:]))(.*)$/))    { from = m[2];                     to=m[3]; rest=m[4]; }
        else report_error("replay", "Unparsable move", { replay });
        replay = rest;
        dprintf("Current move: %s  ", m[1]);

        if (click) {
            dprintf("Click: pile: %s/%d\n", click, base64.from(click))
            this.piles[base64.from(click)].onclick();
            return step(resolve, reject);
        }

        from = base64.from(from);
        to   = base64.from(to);
        n     = n     != undefined ? base64.from(n)     : 1;
        start = start != undefined ? base64.from(start) : this.piles[from].pile.length - n;

        dprintf("Move: pile: %s/%d (%s), start: %d, n: %d, to: %s/%d (%s)\n",
                base64.to(from), from, this.piles[from].name, start, n, base64.to(to), to, this.piles[to].name);
        this.push_state();
        var cd,ma,ne;
        if ((ne = this.piles[from].pile.length < start + n) ||
            (cd = !this.piles[from].can_drag(start)) ||
            (ma = !this.move_affinity(this.piles[from], start, this.piles[to], this.piles[to].pile.length, n))) {
            report_error("replay", sprintf("Illegal move: %s (%s)!\n", m[1], ne ? "not enough cards in from" : cd ? "can't drag" : ma ? "won't accept" : ""),
                         { game: `${this}` });
            reject();
            return;
        }
        if (restoring) { // When restoring a saved game don't bother animating anything so the restore looks instant
            this.piles[from]._move_to_pile(start,n,this.piles[to]);
            this.end_of_move();
            return pile_game.RESTORING; // Avoid recursion, see below
        } else
            this.piles[from].move_to_pile(start,n,this.piles[to], () => step(resolve, reject));
    }.bind(this);
    this.stabilize_state();
    this.ui.lay_out_now(); // This needs to happen before we can replay.
    if (restoring) {
        return new Promise((resolve, reject) => {
            // Call step() in a loop because JS engines don't have tail call optimization
            while (step(resolve, reject) === pile_game.RESTORING) {}
        });
    } else {
        this.stats.cancel();
        return new Promise((resolve, reject) => step(resolve, reject));
    }
  }

  toString() {
    var s = '';
    for (var p in this.piles)
        s += this.piles[p].toString() + "\n";
    return s;
  }

  replay_url() {
    return URL.base + '?' + makeurlparams(merge(URL.param, { game:this.seed, replay:this.moves.join("") }));
  };

  // Move grammar:
  //   moves : <seed> '#' <move>*
  //   move  : <from> <to>                       # one card from top of <from> to top of <to>
  //         | <from> ':' <count> <to>           # top <count> cards of <from> to top of <to>
  //         | <from> '-' <fstart> <count> <to>  # <count> cards from middle of <from> starting at <fstart> to top of <to>
  //         | '*' <pile>                        # Clicked on pile. Game specific--usually the deck
  //         | '*[' <seed> ']'                   # Redeal
  //   from count to fstart pile: <base64-digit> # ABCDEFG...abcdefg...0123456789+/
  add_move(m) {
    if (m.internal) return; // Internal moves are part of the game mechanics and shouldn't be listed in the move list.
    var s, from = m.from, to = m.to, n = m.n, fstart = m.fstart, tstart = m.tstart;
    if (tstart !== undefined && tstart != to.pile.length)
        report_error("add_move", "add support for tstart to add_move", { m });
    if (fstart + n == from.pile.length)
        if (n == 1) s=sprintf("%s%s", from.move_char(), to.move_char());
        else        s=sprintf("%s:%s%s", from.move_char(), base64.to(n), to.move_char());
    else            s=sprintf("%s-%s%s%s", from.move_char(), base64.to(fstart), base64.to(n), to.move_char());
    this.moves.push(s);
  }

  end_of_move() {
    this.stats.set("moves", this.moves.join(""));
    super.end_of_move();
  }

  end(complete) {
    this.stats.set("score", this.score());
    super.end(complete);
  }

  schedule_update(pile) {
    if (!this.update_deferral)
        this.update_deferral = new Deferral(function() {
                for (var i in this._update.piles) {
                    this.piles[+i].fixup_coords();
                    this.piles[+i].update();
                }
                delete this._update;
        }.bind(this));

    if (!this._update)
        this._update = { piles: {} };

    this._update.piles[pile.pilenum] = true;
    this.update_deferral.defer();
  }

  do_updates() {
    this.update_deferral.run();
  }

  animate_move(m, callback, dz) {
    var count=0;
    var finished = function() { // Only call the callback when all the cards have finished animating.
        if (!count-- && callback)
            callback();
    }
    for (var t=0; t<m.length; t++)
        for (var i=0; i<m[t].n; i++)
            if (m[t].tanimate == undefined || m[t].tanimate !== false) {
                count++;
                m[t].removed[i].ui.animate_to(m[t].to, m[t].tstart+i, dz, finished);
            }

    for (var t=0; t<m.length; t++) {
        this.schedule_update(m[t].to);
        this.schedule_update(m[t].from);
    }

    finished();
  }

  do_move(m) {
    for (var t=0; t<m.length; t++) {
        if (m[t].tstart === undefined)
            m[t].tstart = m[t].to.pile.length;
        this.add_move(m[t]);
        var before = (function(pile) { return pile.name + ": " + map(function(c) { return c.toString() }, pile.pile).join(' '); })(m[t].from);
        m[t].removed = m[t].from.splice(m[t].fstart, m[t].n);
        m[t].to.splice.apply(m[t].to, [m[t].tstart , 0].concat(m[t].removed));
        if (m[t].removed.length != m[t].n)
            this.bug("do_move()", "Tried to take more cards than there were in the pile!",
                     { n: m[t].n, fstart: m[t].fstart, from: before, removed: map(function(c) { return ""+c }, m[t].removed) });
    }
    return m;
  }

  // Pile archetypes:
  _gfis_next = [hearts,clubs,spades,diamonds];
  _gfis = spades; // Foundation Icon Suit. (starts at one minus :-)
  gfis_next() {
    return this._gfis = this._gfis_next[this._gfis]
  }

  static generic_foundation = class extends pile {
      constructor(div,game,draggable) {
        super(div,game);

        this.draggable = draggable;
        this.icon = new card("F", this.game.gfis_next(), 0, up, null, game);
        this.icon.ui.draw(this.ui, { x:0, y:0, z:-1 });
      }
      icon_bonus = function(card) {
            return card.suit == this.icon.suit ? 5 : card.red == this.icon.red
      };
      accept_stacks = true;
      accept(card) {
            var tcard = card[card.length-1];
            return ((this.pile.length == 0 && tcard.rank == ace ||
                     this.pile.length      && in_suit_order(this.top(), tcard))
                    && in_order_by(in_suit_order, card) ? 10 + this.icon_bonus(tcard) : 0);
      }
      split_move(start, n, from) {
            var m=[];
            for (var i=start; i<start+n; i++)
                m.push({from:from,to:this,fstart:i,n:1});
            return m.reverse();
      }
      can_drag(index) { return this.draggable && index == this.top_index(); }
      xoffset = 0;
      yoffset = 0;
  };

  redraw() {
    for (var i in this.piles) {
        this.piles[i].redraw();
        this.piles[i].update();
    }
  }


  on_pause () {
    this.ui.on_pause();
  }

  on_unpause () {
    this.ui.on_unpause();
  }

  move_affinity(from_pile, fstart, to_pile, tstart, n) {
    if (tstart != to_pile.pile.length) { report_error("move_affinity", "implement tstart", { from_pile, fstart, to_pile, tstart, n }); return; }
    var card = from_pile.pile.slice(fstart, fstart+n);
    if (to_pile.accept_stacks)
        return to_pile.accept(card, from_pile);
    else if (card.length == 1)
        return to_pile.accept(card[0], from_pile);
  }

  find_target_piles(pile, fstart, n, other_pile) {
    var p = [];
    for (var i in this.piles) {
        var x = { pile: this.piles[i], sort: this.move_affinity(pile, fstart, this.piles[i], this.piles[i].pile.length, n) };
        if (x.pile != pile && x.pile != other_pile && x.sort)
            p.push(x);
    }
    p.sort(function(a,b) { return b.sort - a.sort });
    for (var i in p)
        p[i] = p[i].pile;
    return p;
  }
}

module.exports = {
    // Should probably be in cards.js:
    joker: joker,
    ace: ace,
    jack: jack,
    queen: queen,
    king: king,
    foundation: foundation,
    clubs: clubs,
    diamonds: diamonds,
    hearts: hearts,
    spades: spades,
    up: up,
    down: down,
    card: card,
    in_color_order: in_color_order,
    in_color_wrap_order: in_color_wrap_order,
    in_off_color_order: in_off_color_order,
    in_off_color_wrap_order: in_off_color_wrap_order,
    in_suit_order: in_suit_order,
    in_suit_wrap_order: in_suit_wrap_order,
    in_different_suit_order: in_different_suit_order,
    in_numeric_order: in_numeric_order,
    in_numeric_wrap_order: in_numeric_wrap_order,
    in_order_by: in_order_by,
    count_top_order_by: count_top_order_by,
    score_run: score_run,
    score_order_by: score_order_by,

    // Actual piles stuff:
    pile_game: pile_game,
    pile: pile,
    generic_foundation: pile_game.generic_foundation,
    drag_max_given_free: drag_max_given_free,
    empty_pile_count: empty_pile_count,
    base64: base64
};
// Copyright 2005-2010 Jim Radford <radford@blackbean.org>, David Caldwell <david@porkrind.org>

var plat = require('./platform');
var Prefs = require('./prefs');
var dom = require('./dom'), on_load=dom.on_load, on_unload=dom.on_unload, timeout=dom.timeout, cancel_timeout=dom.cancel_timeout, URL=dom.URL, Deferral=dom.Deferral;
var lib = require('./lib'), merge=lib.merge, merge_into=lib.merge_into, map=lib.map, rand=lib.rand, add=lib.add;
var debug = require('./debug'), maybe_try=debug.maybe_try, maybe_try_wrap=debug.maybe_try_wrap, try_report=debug.try_report, report_error=debug.report_error;
var seed_game = require('./seed_game');
var options = require('./options'), get_options=options.get_options;
var ajax = require('./ajax'), makeurl=ajax.makeurl, makeurlparams=ajax.makeurlparams;
var prnt = require('./print'), print=prnt.print, sprintf=prnt.sprintf, dprintf=prnt.dprintf;
var Alert = require('./alert'), new_text_alert=Alert.new_text_alert;

var joker = 0, ace = 1, jack = 11, queen = 12, king = 13, foundation = 14;
var clubs = 0, diamonds = 1, hearts = 2, spades = 3;
var suit_string = ['C','D','H','S'];
var rank_string = ['R','A','2','3','4','5','6','7','8','9','10','J','Q','K','F'];
var up=1,down=0;

function card(rank, suit, index, face, deck, game) {
    this.rank   = rank;
    this.suit   = suit;
    this.index  = index;
    this.face   = face;
    this.deck   = deck;
    this.red    = suit == diamonds || suit == hearts;
    this.black  = suit == clubs    || suit == spades;
    this.string = (typeof this.rank == "number" ? this.rank==joker ? 'J'                          : rank_string[this.rank] : this.rank)
                + (typeof this.suit == "number" ? this.rank==joker ? ['1','2','3','4'][this.suit] : suit_string[this.suit] : "");
    this.ui     = new game.piles_ui.card_ui(this, game);
}
card.prototype.toString = function() { return this.face == down ? this.string.toLowerCase() : this.string; }
card.prototype.toJSON   = function() { return this.toString(); }
card.prototype.turn_face = function(face) { this.face = face; return this }

function in_color_order(card1, card2) {
    return card1.rank+1 == card2.rank && card1.red == card2.red && card1.face == up && card2.face == up;
}

function in_color_wrap_order(card1, card2) {
    return (card1.rank == king && card2.rank == ace ||
            card1.rank+1 == card2.rank) && card1.red == card2.red && card1.face == up && card2.face == up;
}

function in_off_color_order(card1, card2) {
    return card1.rank+1 == card2.rank && card1.red != card2.red && card1.face == up && card2.face == up;
}

function in_off_color_wrap_order(card1, card2) {
    return (card1.rank == king && card2.rank == ace ||
            card1.rank+1 == card2.rank) && card1.red != card2.red && card1.face == up && card2.face == up;
}

function in_suit_order(card1, card2) {
    return card1.rank+1 == card2.rank && card1.suit == card2.suit && card1.face == up && card2.face == up;
}

function in_suit_wrap_order(card1, card2) {
    return (card1.rank == king && card2.rank == ace ||
            card1.rank+1 == card2.rank) && card1.suit == card2.suit && card1.face == up && card2.face == up;
}

function in_different_suit_order(card1, card2) {
    return card1.rank+1 == card2.rank && card1.suit != card2.suit && card1.face == up && card2.face == up;
}

function in_numeric_order(card1, card2) {
    return card1.rank+1 == card2.rank && card1.face == up && card2.face == up;
}

function in_numeric_wrap_order(card1, card2) {
    return (card1.rank == king && card2.rank == ace ||
            card1.rank+1 == card2.rank) && card1.face == up && card2.face == up;
}

function in_order_by(f, cards, start) {
    for (var i=start||0; i<cards.length-1; i++)
        if (!f(cards[i+1],cards[i]))
            return false;
    return cards[i].face == up; // this is compatability in the n == 1 case with all the '== up' checks in in_*_order()
}

function count_top_order_by(f, cards, start) {
    if (start == undefined) start = cards.length-1; // our stupid babel doesn't have ??
    var count=0;
    for (var i=start; i>=0; i--, count++)
        if (i<start && !f(cards[i+1], cards[i]))
            break;
    return count;
}

function score_run(n) {
    var sum = n => n*(n+1)/2;
    return Math.floor(sum(n)*13/sum(13));
}

function score_order_by(f, cards, start) {
    var count=0, run=0;
    for (var i=start||0; i<cards.length-1; i++)
        if (f(cards[i+1],cards[i])) {
            run += run ? 1 : 2;
        } else {
            count += score_run(run);
            run = 0;
        }
    return count + score_run(run);
}

// This is only called once, ever (unless you have two decks)
function init_deck(jokers, game) {
    var cards = [], deck = {};
    for (var i=0,s=clubs; s<=spades; s++)
        for (var n=1; n<=king; n++,i++)
            cards[i] = new card(n,s,i,down,deck,game);
    for (var s=0; s<jokers; s++,i++)
        cards[i] = new card(joker,s,i,down,deck,game);
    return cards;
}


function shuffle(deck, times) {
    if (times == undefined)
        times = 7;
    for (var i=0; i<times; i++)
        for (var a in deck) {
            var b = rand() % deck.length;
            var tmp = deck[a];
            deck[a] = deck[b];
            deck[b] = tmp;
        }
    return deck;
}

function translate(a, b) {
    return {x : a.x + b.x, y: a.y + b.y };
}

function point_distance(a, b) {
    return Math.sqrt((a.x-b.x)*(a.x-b.x) + (a.y-b.y)*(a.y-b.y));
}

var base64 = {
    enc:"0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ!@",
    to: function(n) {
        return 0 <= n && n < base64.enc.length ? base64.enc.slice(n,n+1) : "?";
    },
    from: function(c) {
        return base64.enc.indexOf(c);
    }
}

function dup(object) {
    return merge_into({}, object);
}

class pile {
  constructor(div,game,empty) {
    this.game = game;
    this.name = div;
    this.pile = [];
    this.ui = new game.piles_ui.pile_ui(div, this);
    if (!this.ui) throw("No ui-cookie found for "+div);
    this.origin ??= { x:0, y:0 };
    if (this.xoffset       == undefined)  this.xoffset = 0;
    if (this.yoffset       == undefined)  this.yoffset = 30/131;
    if (this.accept_stacks == undefined)  this.accept_stacks = false;
    if (this.drag_stacks   == undefined)  this.drag_stacks = true;
    if (empty ?? true) {
        this.empty = new card("empty-pile", undefined, undefined, up, null, game);
        this.redraw_empty();
    }
    this.ui.set_drag_start_handler(this.drag_start = maybe_try_wrap(this, function(e) {
        if ("button" in e && e.button != plat.left_button) return; // only deal with left click for now.
        this.game.stabilize_state();
        var drag = { i: undefined, handle: { x:0, y:0 }, start: { x: e.targetX, y: e.targetY, time: Date.now() }, animations: [] };
        drag.anim_callback = function() {
            let callbacks = {};
            drag.animations.push(new Promise((resolve, reject) => callbacks = { resolve, reject }));
            return callbacks.resolve;
        };
        drag.animations_done = () => Promise.all(drag.animations);

        this.game.add_event_history({ pile:this.name, kind: "onmousedown", event: dup(e), drag: dup(drag) });

        if (this.onclick) if (this.onclick(e) !== false) return false;
        if (!this.pile.length) return;
        if (this.game.is_paused()) return false;

        for (var i=this.top_index(); i>=0; i--) {
            var c = this.coords(i);
            if (e.targetX >= c.x && e.targetX < c.x + 1 &&
                e.targetY >= c.y && e.targetY < c.y + 1) {
                drag.i = i;
                drag.handle.x = e.targetX - c.x;
                drag.handle.y = e.targetY - c.y;
                break;
            }
        }
        if (drag.i == undefined) return false;

        drag.state = game.get_state();

        // Keep track of what is initially visible to the player so we don't go too crazy with fpreliminaries.
        drag.fvisible = this.pile.map(c => c.face == up);

        drag.fpreliminaries = [];
        while (!this.can_drag(drag.i)) {
            var fpreliminary = undefined;
            for (var i = drag.i+1; i<this.pile.length; i++) {
                if (this.can_drag(i) && drag.fvisible[i]) {
                    var n = this.drag_stacks ? this.pile.length-i : 1;
                    var destinations = game.find_target_piles(this, i, n);
                    if (destinations.length) {
                        fpreliminary = this._move_to_pile(i, n, destinations[0]);
                        break;
                    }
                }
            }
            if (!fpreliminary) {
                game.set_state(drag.state, true);
                return false;
            }
            drag.fpreliminaries.push(fpreliminary);
        }

        this.game.drag = drag; // Ok, we're dragging something now.... Maybe
        drag.card = this.pile.slice(drag.i, this.drag_stacks ? this.pile.length : drag.i+1);
        for (var i in drag.card)
            drag.card[i].dragging = true; // stops certain animations from happening. We want to control this card.

        drag.destinations = [];
        {
            var state = game.get_state();
            for (var gpi in game.piles) {
                var p = game.piles[gpi];
                if (p == this)
                    continue;
                var tpreliminaries = [];
                // Keep track of what is initially visible to the player so we don't go too crazy with
                // tpreliminaries. We can't check the card face later since we mess with the state and so it's
                // _always_ "up".
                var tvisible = p.pile.map(c => c.face == up);
                do {
                    var affinity;
                    if ((p.pile.length == 0 || tvisible[p.top_index()]) && // Don't play onto the top card if wasn't initially visible.
                        (affinity = game.move_affinity(this, drag.i, p, p.pile.length, drag.card.length))) {
                        var destination = { to: p,    tstart: p.pile.length, tpreliminaries: tpreliminaries.slice(0), subsequents: [],
                                            from: this, fstart: drag.i, n: drag.card.length, removed: drag.card, affinity: affinity };
                        {
                            var save = game.get_state();
                            // do the move so we can look for subsequent moves (sht.html?game=26999559 move the KC to the QC column)
                            this._move_to_pile(drag.i, drag.card.length, p); // should be game.do_move([destination]), but it doesn't split the move?

                            do {
                                var subsequent = undefined, affinity = 0, preliminary = undefined;
                            subsequent:
                                for (var tp=0; tp<destination.tpreliminaries.length; tp++) {
                                    for (var tpi=destination.tpreliminaries[tp].length-1; tpi>=0; tpi--) {
                                        var pre = destination.tpreliminaries[tp][tpi], new_affinity;
                                        if (pre.n == pre.to.pile.length - pre.tstart &&
                                            pre.to.can_drag(pre.tstart) &&
                                            affinity < (new_affinity = game.move_affinity(pre.to, pre.tstart, p, p.pile.length, pre.n)))
                                        {
                                            affinity = new_affinity;
                                            preliminary = pre;
                                        }
                                    }
                                }
                                if (preliminary) {
                                    subsequent = preliminary.to._move_to_pile(preliminary.tstart, preliminary.n, p);
                                    subsequent[0].fanimate = preliminary.tanimate = false; // skip the pre move and just animate the subsequent
                                    destination.subsequents.push(subsequent);
                                }
                            } while(subsequent);

                            game.set_state(save, true);
                        }
                        drag.destinations.push(destination);
                    }

                    // try moving the something off the top as a preliminary move
                    var tpreliminary = undefined;
                    for (var pi = 0; pi < p.pile.length; pi++) {
                        if (tvisible[pi] && p.can_drag(pi)) { // Don't try to move it if it wasn't initially visible.
                            var n = p.drag_stacks ? p.pile.length-pi : 1;
                            var destinations = game.find_target_piles(p, pi, n, this);
                            if (destinations.length) {
                                var save = game.get_state();
                                tpreliminary = p._move_to_pile(pi, n, destinations[0]);
                                if (this.can_drag(drag.i)) // The preliminary might invalidate our current move (drag_max_given_free()).
                                    tpreliminaries.push(tpreliminary);
                                else {
                                    game.set_state(save, true);
                                    tpreliminary = undefined;
                                }
                                break;
                            }
                        }
                    }
                } while (tpreliminary);
                game.set_state(state, true);
            }
        }
        drag.destinations.sort(function(a,b) { return (!b.tpreliminaries.length - !a.tpreliminaries.length) // avoid tpreliminaries
                                                   || (b.affinity - a.affinity) });

        //print("--\n"); for (var i in drag.destinations) print_structure(drag.destinations[i], "d[" + i + "]");

        this.game.allow_pause(0); // disable pause for the drag

        this.ui.set_drag_handler(function(e) {
          maybe_try(function() {
            if (!drag.ged) {
                for (var i in drag.fpreliminaries)
                    this.game.animate_move(drag.fpreliminaries[i], drag.anim_callback());
                drag.ged = true;
            }

            this.game.add_event_history({ pile:this.name, kind: "onmousemove", event: dup(e), drag: dup(drag) });
            for (var i=0; i<drag.card.length; i++)
                drag.card[i].ui.draw(this.ui,{ x: e.targetX - drag.handle.x + this.xoff()*i,
                                               y: e.targetY - drag.handle.y + this.yoff()*i,
                                               z: i }, 100);

            // This is really slow :-(
            // Highlight the best pile
            var m = this.find_best_move(drag.destinations, { x: e.targetX - drag.handle.x, y: e.targetY - drag.handle.y });

            if (!m || drag.destination != undefined && drag.destination != m) {
                if (drag.destination) {
                    if (drag.destination.prestate)
                        this.game.set_state(drag.destination.prestate, true);
                    for (var i = drag.destination.subsequents.length-1; i >= 0; i--) // undo previously displayed moves
                        this.game.animate_move(this.reverse_move(drag.destination.subsequents[i]), drag.anim_callback());
                    for (var i = drag.destination.tpreliminaries.length-1; i >= 0; i--) // undo previously displayed moves
                        this.game.animate_move(this.reverse_move(drag.destination.tpreliminaries[i]), drag.anim_callback());
                    delete drag.destination.prestate;
                    delete drag.destination.move;
                    delete drag.destination;
                }
                if (drag.hover_timeout)
                    drag.hover_timeout = cancel_timeout(drag.hover_timeout);
            }
            if (m && (drag.destination ? drag.destination != m : !drag.hover_timeout)) {
                if (drag.hover_timeout)
                    drag.hover_timeout = cancel_timeout(drag.hover_timeout);
                drag.hover_timeout = timeout(1000, function() {
                    drag.destination.prestate = game.get_state();
                    for (var i in m.tpreliminaries) // draw the current moves
                        this.game.animate_move(this.game.do_move(m.tpreliminaries[i]), drag.anim_callback());
                    drag.destination.move = this._move_to_pile(drag.i, drag.card.length, m.to);
                    for (var i in m.subsequents) // draw the current moves
                        this.game.animate_move(this.game.do_move(m.subsequents[i]), drag.anim_callback(), 100000);
                    delete drag.hover_timeout;
                }.bind(this));
                drag.destination = m;
            }

            // Hilight the top pile.
            if (m)
                this.game.highlight.highlight(m.to, m.tstart)
            else
                this.game.highlight.erase();

          }.bind(this), function(e) {
              this.game.report_error("onmousemove()", e);
          }.bind(this));

          return false;
        }.bind(this));
        this.ui.set_drag_end_handler(this.game.drag.end = function(e) {
            if ("button" in e && e.button != plat.left_button) return; // only deal with left click for now.
            var m;

          maybe_try(function() {
            this.game.add_event_history({ pile:this.name, kind: "onmouseup", event: dup(e), drag: dup(drag) });
            this.game.allow_pause(1); // enable pause now that the drag has finished

            if (e.cancel_drag)
                m = void 0;
            else if (!drag.ged ||  // single click is the new double_click!
                     Date.now() - drag.start.time < 250/*ms*/ && point_distance(drag.start, {x:e.targetX, y: e.targetY}) < game.ui.cardset_pixels(50)) // Probably meant this as a single click
                m = drag.destinations[0]; // This was sorted so the best is first.
            else
                m = this.find_best_move(drag.destinations, { x: e.targetX - drag.handle.x, y: e.targetY - drag.handle.y });

            if (drag.hover_timeout) {
               drag.hover_timeout = cancel_timeout(drag.hover_timeout);
               delete drag.destination; // hasn't animated yet, so don't pretend we have
            }

            this.game.highlight.erase();
            delete this.game.drag; // do this before move_to_pile can cancel the drag

            for (var i in drag.card)
                delete drag.card[i].dragging;

            drag.m = m;
            if (m) {
                game.push_state(drag.state);
                if (!drag.ged)
                    for (var i in drag.fpreliminaries)
                        this.game.animate_move(drag.fpreliminaries[i], drag.anim_callback());
                if (drag.destination != m) { // only need to move stuff if we didn't commit earlier during a hover_timeout
                    for (var i in m.tpreliminaries) { // do and draw the current moves
                        // this should be m.tpreliminaries[i].do() or move_to_pile(), but we have the *result* of _move_to_pile, not the input!
                        this.game.animate_move(this.game.do_move(m.tpreliminaries[i]), drag.anim_callback());
                    }
                    this.move_to_pile(drag.i, drag.card.length, m.to, drag.anim_callback());
                    for (var i in m.subsequents)
                        // this should be m.subsequents[i].do() or move_to_pile(), but we have the *result* of _move_to_pile, not the input!
                        this.game.animate_move(this.game.do_move(m.subsequents[i]), drag.anim_callback());
                } else
                    this.game.animate_move(drag.destination.move, drag.anim_callback());
            } else {
                this.game.animate_move([{ from:this, to:this, tstart:drag.i, n:drag.card.length, removed:drag.card }], drag.anim_callback());
                if (drag.state) game.set_state(drag.state, true); // put the game state back before we animate so cards get unflipped if nec
                for (i = drag.fpreliminaries.length-1; i >= 0; i--)
                    this.game.animate_move(this.reverse_move(drag.fpreliminaries[i]), drag.anim_callback());
            }
          }.bind(this), function(e) {
              this.game.report_error("onmouseup()", e, { m:m, drag: drag, event_history: this.game.event_history });
          }.bind(this));

          this.ui.drag_complete();
        }.bind(this));
        return false;
    }, function(e) {
        delete this.game.drag; // Don't leave this lying around
        this.game.report_error("onmousedown()", e);
        return false;
    }));
    this.pilenum = this.game.piles.length;
    this.game.piles.push(this);
  }

  async fake_click(index) {
    var c = this.coords(index);
    var fake_event = { targetX:c.x, targetY:c.y };
    this.drag_start(fake_event);
    let drag = this.game.drag;
    if (!drag) // The drag_start might have decided nothing was movable.
        return false;
    drag.end(fake_event);
    await drag.animations_done();
    return drag.m;
  }

  toString() { return this.name + ": " + this.pile; }
  toJSON() { var o = {}; o[this.name] = this.pile; return o; }

  update_stats() {
    this.game.stats.set(this.name,        this.pile.length);
    this.game.stats.max(this.name+"_max", this.pile.length);
    this.game.stats.min(this.name+"_min", this.pile.length);
  }

  pop() {
    return this.splice(this.top_index(), 1)[0];
  }

  push(card) {
    return this.splice(this.pile.length, 0, card);
  }

  shift() {
    return this.splice(0, 1)[0];
  }

  unshift(card) {
    return this.splice(0, 0, card);
  }

  top() {
    if (!this.pile.length) alert("there is no top of an empty pile");
    return this.pile[this.top_index()];
  }

  top_index() {
    return this.pile.length-1;
  }

  xoff() { return this.xoffset; }
  yoff() { return this.yoffset; }

  coords(_index, _pile_length) {
    var index = +_index, pl = _pile_length || this.pile.length, dx = this.xoff(), dy = this.yoff();
    return { x: this.origin.x + index * dx,
             y: this.origin.y + index * dy,
             z: index + (this.zoffset||0) };
  }

  // coords(_index, _pile_length) {
  //     var index = +_index, pl = _pile_length || this.pile.length;
  //     if (index <= 0) return { x:0, y:0 };
  //     var l = this.coords(index-1, pl);
  //     return { x: Math.max(0, l.x + Math.max(Math.min(6,this.xoff()), this.xoff() - 2*(pl - index))),
  //              y: Math.max(0, l.y + Math.max(Math.min(6,this.yoff()), this.yoff() - 2*(pl - index))),
  //              z: index + (this.zoffset||0) };
  // }
  // coords(_index, _pile_length) {
  //     var index = +_index, pl = _pile_length || this.pile.length;
  //     var c = { "x": (pl > 0 ? Math.max(0, index*(this.xoff()+1)-((index+1)*index)/2 - index*(pl-index-1)) : index*this.xoff()),
  //               "y": (pl > 0 ? Math.max(0, index*(this.yoff()+1)-((index+1)*index)/2 - index*(pl-index-1)) : index*this.yoff()),
  //               "z": index + (this.zoffset||0) };
  //     return c;
  // }


  redraw_empty() {
    if (this.empty)
        this.empty.ui.draw(this.ui, { ...this.coords(0), z:-2 });
  }

  redraw() {
    this.redraw_empty();
    for (var c=0; c<this.pile.length; c++)
        this.pile[c].ui.draw(this.ui, this.coords(c));
  }

  fixup_coords() {
    for (var c=0; c<this.pile.length; c++) {
        var pc = this.coords(c),
            cc = this.pile[c].ui.coords;
        if (!this.pile[c].dragging && (cc.x != pc.x || cc.y != pc.y || this.pile[c].pile_ui != this.ui))
            this.pile[c].ui.animate_to(this, c);
    }
  }

  update() {
    this.game.stats.set(this.name, this.pile.length);
    //print("Updating pile "+this.name+", width="+card_width+"\n");
    for (var c=0; c<this.pile.length; c++) {
        this.pile[c].ui.update_face();
        this.pile[c].ui.set_cursor(this.can_drag(c) ? "move" : "default");
    }
    var i = this.overlap ? 0 : Math.max(this.pile.length == 0 ? 0: this.top_index(), (this.maxstack||1)-1);
    var c0 = this.coords(0), ci = this.coords(i);
    this.ui.set_size(1 + Math.abs(ci.x - c0.x), 1 + Math.abs(ci.y - c0.y));
    this.ui.update();
  }

  splice(start, n/*, card1, card12, ...*/) {
    var removed = this.pile.splice.apply(this.pile, arguments);
    this.update_stats();
    return removed;
  };

  splice_and_turn_over(start, n/*, card1, card12, ...*/) {
    var removed = pile.prototype.splice.apply(this, arguments);
    if (this.pile.length && arguments.length <= 2/*don't turn over when adding cards*/)
        this.top().face = up;
    return removed;
  }

  splice_and_turn_under(start, n/*, card1, card12, ...*/) {
    if (this.pile.length && arguments.length > 2/*don't turn over when removing cards*/)
        this.top().face = down;
    return pile.prototype.splice_and_turn_over.apply(this, arguments);
  }
  move_char() {
    return base64.to(this.pilenum);
  }

  reverse_move(move) {
    return map(function(m) { return { from:m.to, to:m.from, n:m.n, fstart:m.tstart, tstart:m.fstart,
                                      removed:m.removed, fanimate:m.tanimate, tanimate:m.fanimate    } }, move);
  }

  _move_to_pile(start, n, to) {
    var m = to.split_move ? to.split_move(start, n, this) : [{from:this,to:to,fstart:start,n:n}];
    if (this.append_moves) m.push.apply(m, this.append_moves(start, n));
    this.game.do_move(m);
    return m;
  }

  move_to_pile(start, n, to, callback) {
    this.game.stabilize_state();
    this.game.animate_move(this._move_to_pile(start, n, to), callback);
    this.game.end_of_move();
  }

// This should be overridden.
// If pile.accept_stacks is true then card is an array of cards, otherwise it is a single card.
// pile.accept() should return a priority that tells how "desirable" this partical move would be.
// This is used for when the user double clicks a pile. The highest priority pile will become the
// final destination. If there are multiple piles with the same priority then on will be picked
// randomly (whatever sort happens to return first).
  accept  (card)  { return 1; }

// This should be overridden.
// This gets passed the index of a card in the pile. It should return whether the user is allowed
// to drag that card (and all the cards above it if it isn't the top card in the pile).
  can_drag(index) { return true; } // Should be overridden!

// Finds all piles that intersect a given card. Returns pile with largest area of intersection.
  find_best_move(inm, coords) {
    var m = [];
    var p = translate(this.ui.coords, coords);
    for (var i in inm) {
        var p_i = translate(inm[i].to.ui.coords, inm[i].to.coords(inm[i].tstart));
        var dx = Math.abs(p.x - p_i.x), dy = Math.abs(p.y - p_i.y);
        if (dx < 1 && dy < 1)
            m.push({ area: dx * dy, move: inm[i] });
    }
    m.sort(function(a,b) { return a.area - b.area });
    // pick the pile with highest overlapping area
    if (m.length) return m[0].move;
  }
}

function find(array, card) {
    for (var i in array)
        if (array[i] == card)
           return i;
}

function drag_max_given_free(piles, dest)
{
    var drag_max = 1;
    for (var i in piles)
        if (piles[i].pile.length == 0 && piles[i] !== dest)
            drag_max *= 2;
    return drag_max;
}

function empty_pile_count(piles) {
    var free = 0;
    for (var i in piles)
        if (piles[i].pile.length == 0)
            free++;
    return free;
}

class pile_game extends seed_game {
  pile_game_init(name, piles_ui) {
    this.seed_game_init(name,piles_ui);

    if (!this.options) this.init_options(name);

    this.piles = [];

    this.piles_ui = piles_ui; // so pile() constructor can get it
    this.ui = new piles_ui.pile_game_ui(this);

    this.fresh_deck = [];
    for(var i=0; i<8; i++) this.fresh_deck.push(init_deck(0, this));

    this.highlight = new card("highlight",undefined,undefined,up,null,this);
    this.highlight.highlight = function(pile, n) {
        this.ui.draw(pile.ui, pile.coords(n), 0.5);
    };
    this.highlight.erase = function() { this.ui.erase(); }
    on_unload(() => this.save_game());
  }

  init_options(name) {
    let variants = this.constructor.variants ?? this.variants ?? {};
    this.options = get_options(this.valid_options || {}, variants[name]);
  }

  new_game(seed) {
    super.new_game(seed);

    // remove all cards from existing piles
    for (var p in this.piles)
        this.piles[p].pile.splice(0,this.piles[p].pile.length);
    for (var i in this.fresh_deck)
        for (var c in this.fresh_deck[i])
           this.fresh_deck[i][c].face = down;

    // Actually start
    this.moves = [];
    this.state = {};
    this.start_stats();
    this.stats.set("moves", "");
    for (var i in this.options)
        this.stats.set("options_"+i, this.options[i]);
    var decks = []; for (var i=0; i<(this.decks||1); i++) decks.push.apply(decks, this.fresh_deck[i]);
    this.deal(shuffle(decks, this.seed == -1 ? 0 : 7));
    this.ui.backs_visible(this.backs_visible());
    this.redraw();
    for (var p in this.piles)
        this.schedule_update(this.piles[p]);
    var me = this;
    //on_unload(function() { me.stats.done(); });
  }

  save_game() {
    if (this.ended) return; // Don't save games that have ended!
    if (this.moves.length == 0) return; // Don't save brand new games
    let save_state = JSON.stringify({
        seed: this.seed,
        moves: this.moves.join(""),
        stats: this.stats.save(),
    });
    localStorage.setItem(`saved-game_${this.name}`, save_state);
  }

  restore_game() {
    let saved_seed = this.seed;
    let saved_game = try_report(() => localStorage.getItem(`saved-game_${this.name}`), "restore_game()");
    if (!saved_game) return; // nothing to restore
    try_report(() => localStorage.removeItem(`saved-game_${this.name}`), "restore_game()");
    try {
        let save_state = JSON.parse(saved_game);
        this.stats.cancel(); // don't send off a score for a zero move game that existed for less than a millisecond
        this.new_game(save_state.seed);
        this.replay(save_state.moves, true)
            .then(() => {
                this.stats.restore(save_state.stats);
                this.ui.game_restored();
            });
    } catch(e) {
        new_text_alert("There was a saved game but I was unable to restore it. Sorry.");
        report_error("restore_game", e, { saved_game });
        this.new_game(saved_seed);
    }
  }

  backs_visible() {
    for (var p in this.piles)
        for (var c in this.piles[p].pile)
            if (this.piles[p].pile[c].face === down)
                return true;
  }

  set_state(old, noupdate) {
        super.set_state(old);
        this.moves = old.moves.slice(0);
        this.state = merge({}, old.state);
        this.stats.set("moves", this.moves.join(""));
        for (var p in old.pile) {
            this.piles[p].pile = [];
            for (var c in old.pile[p]) {
                this.piles[p].pile[c]      = old.pile[p][c].card;
                this.piles[p].pile[c].face = old.pile[p][c].face;
            }
	    this.piles[p].update_stats();
        }
        if (!noupdate)
            for (var p in this.piles)
                this.schedule_update(this.piles[p]);
  }

  get_state() {
    var old = super.get_state();
    old.moves = this.moves.slice(0);
    old.pile = [];
    old.state = merge({}, this.state);
    for (var p in this.piles) {
      try_report(function() { // TEMP: remove try/catch after debugging http://greenfelt.net/errors?e=e278267b26
        old.pile[p] = [];
        for (var c in this.piles[p].pile)
          try_report(function() { // TEMP: remove try/catch after debugging http://greenfelt.net/errors?e=87e32e2440
            old.pile[p][c] = { card: this.piles[p].pile[c], 
                               face: this.piles[p].pile[c].face };
          }.bind(this), "get_state()", { p:p, c:c, "this.piles[p].pile[c]": String(this.piles[p].pile[c]) });
      }.bind(this), "get_state() outer loop", { p:p, "this.piles[p]": String(this.piles[p]) });
    }
    return old;
  }

  best_pile(from_pile, fstart, piles) {
    var dest = [];
    for (var p in piles)
        dest.push({ index:p, score:this.move_affinity(from_pile, fstart, piles[p], piles[p].pile.length, 1) });
    dest.sort(function(a,b) { return b.score - a.score });
    return dest[0].score ? dest[0].index : undefined;
  }

  complete_generic(good, from) {
    var any = 0;
    var step = (cards) => {
        if (!cards) return;
        if (this.drag) return; // move_to_pile will cancel (via stabilize_state) any drag which might change game state out from under us
        var testpile = (from, cards) => {
            for (var c=from.top_index(); c>=0 && (!from.drag_stacks || c==from.top_index()); c--) {
                var g;
                if ((g = this.best_pile(from, c, good)) != undefined) {
                    from.move_to_pile(c, 1, good[g], () => step(1));
                    cards--; any++;
                    timeout(137, () => step(cards));
                    return cards;
                }
            }
            return cards;
        };
        for (var f in from)
            for (var p in from[f])
                if (from[f][p].pile.length)
                    if (!(cards = testpile(from[f][p], cards)))
                        return;
    };
    step(3);
    return any;
  }

  count_cards_in(piles) {
    return add(map(function(p) { return p.pile.length }, piles));
  }

  create_deck(deck, play, cards, redeal) {
    if (redeal == undefined || redeal === true) redeal = Infinity;
    if (redeal === false) redeal = 0;
    this.ui.deck_play = deck.onclick = function() {
        if (deck.pile.length == 0 && (play.pile.length <= cards || deck.redeals() >= redeal))
            return false; // pointless
        this.push_state();
        deck.turn();
        this.moves.push("*"+deck.move_char());
        this.end_of_move();
    }.bind(this);
    deck.redeals = () => this.state.redeals = this.state.redeals || 0;
    deck.turn = function() {
        if (deck.pile.length == 0) { // already checked if we are allowed to in deck_play()
            this.state.redeals++;
            while (play.pile.length) {
                var card = play.pop();
                card.face = down;
                deck.push(card);
                card.ui.cancel_animation(); // The card might still be flying around from another very recent click (or an undo or something)
            }
            this.stats.inc("deck flipped");
            deck.redraw();
            play.redraw();
            this.schedule_update(deck);
        }
        for (var i=0; i<cards && deck.pile.length; i++) {
            // Consider converting this to animate_move()--requires thinking about moves and the '*' move, especially flipping the deck (above)
            var card = deck.pop();
            card.face = up;
            play.push(card);
        }
        deck.game.schedule_update(play); // For N-turn games we may need to update because coords() just changed. Only noticeable when there's less than N cards in the deck
        deck.ui.update(); // This is so the card count hover title thing updates.
    }.bind(this);

    deck.accept = function(card) { return false; }
    deck.can_drag = function(index) { return false; }
    deck.xoffset = 1/90;
    deck.yoffset = 1/131;
    deck.maxstack = 52 * (this.decks||1);
    deck.title = true;
    deck.icon = new card("redeal", void 0, 0, up, null, this);
    deck.update_redeal = () => {
        if (deck.redeals() >= redeal)
            deck.icon.ui.erase();
        else
            deck.icon.ui.draw(deck.ui, { x:0, y:0, z:-1 });
    }
    deck.update = () => {
        pile.prototype.update.apply(deck);
        deck.update_redeal();
    }
    if (cards == 1 && plat.webkit) // only when we show only the top card is this optimization possible
        play.splice = play.splice_and_turn_under;
    play.accept = function(card) { return false; }
    play.can_drag = function(index) { return index == this.top_index(); }
    play.xoffset = 30/90;
    play.yoffset = 0;
    play.title = true;
    play.maxstack = cards;
    play.coords = function(_index, _pile_length) {
        var index = +_index, pl = _pile_length || this.pile.length;
        var c = Math.max(0, cards+index-Math.max(cards,this.pile.length));
        return { x: c*this.xoff(), y: c*this.yoff(), z: index };
    }
  }

  extra_error(extra) {
      return super.extra_error(merge(extra || {},
                                     { moves   : this.stats.current && this.stats.current.moves,
                                       replay  : this.replay_url() }));
  };

  event_history = [];
  add_event_history(entry) {
    this.event_history.push(merge({ timestamp:Date.now() },
                                  entry));
    if (this.event_history.length > 5) this.event_history.shift();
  }

  stabilize_state () {
    super.stabilize_state();
    if (this.drag)
        this.drag.end({ cancel_drag: true });
  }

// Override this to convert moves in older games to their modern equivalents.
  fix_replay_move(r) { return r };

// Moves:
// <from><to>
// <from>:<number-of-cards-from-top><to>
// <from>-<start><length><to>
// *<pile>  call piles "onclick" handler
  static  RESTORING = Symbol("RESTORING");
  replay(replay, restoring, callback) {
    var step = function(resolve, reject) {
        if (replay == "") { dprintf("Done\n"); return resolve(this.score()); }
        replay = this.fix_replay_move(replay);
        var m, from , start, n, to, rest, click;
        if      (m = replay.match(/^(\*(.))(.*)$/))         { click= m[2];                              rest=m[3]; }
        else if (m = replay.match(/^((.)-(.)(.)(.))(.*)$/)) { from = m[2]; start=m[3]; n=m[4]; to=m[5]; rest=m[6]; }
        else if (m = replay.match(/^((.):(.)(.))(.*)$/))    { from = m[2];             n=m[3]; to=m[4]; rest=m[5]; }
        else if (m = replay.match(/^((.)([^-:]))(.*)$/))    { from = m[2];                     to=m[3]; rest=m[4]; }
        else report_error("replay", "Unparsable move", { replay });
        replay = rest;
        dprintf("Current move: %s  ", m[1]);

        if (click) {
            dprintf("Click: pile: %s/%d\n", click, base64.from(click))
            this.piles[base64.from(click)].onclick();
            return step(resolve, reject);
        }

        from = base64.from(from);
        to   = base64.from(to);
        n     = n     != undefined ? base64.from(n)     : 1;
        start = start != undefined ? base64.from(start) : this.piles[from].pile.length - n;

        dprintf("Move: pile: %s/%d (%s), start: %d, n: %d, to: %s/%d (%s)\n",
                base64.to(from), from, this.piles[from].name, start, n, base64.to(to), to, this.piles[to].name);
        this.push_state();
        var cd,ma,ne;
        if ((ne = this.piles[from].pile.length < start + n) ||
            (cd = !this.piles[from].can_drag(start)) ||
            (ma = !this.move_affinity(this.piles[from], start, this.piles[to], this.piles[to].pile.length, n))) {
            report_error("replay", sprintf("Illegal move: %s (%s)!\n", m[1], ne ? "not enough cards in from" : cd ? "can't drag" : ma ? "won't accept" : ""),
                         { game: `${this}` });
            reject();
            return;
        }
        if (restoring) { // When restoring a saved game don't bother animating anything so the restore looks instant
            this.piles[from]._move_to_pile(start,n,this.piles[to]);
            this.end_of_move();
            return pile_game.RESTORING; // Avoid recursion, see below
        } else
            this.piles[from].move_to_pile(start,n,this.piles[to], () => step(resolve, reject));
    }.bind(this);
    this.stabilize_state();
    this.ui.lay_out_now(); // This needs to happen before we can replay.
    if (restoring) {
        return new Promise((resolve, reject) => {
            // Call step() in a loop because JS engines don't have tail call optimization
            while (step(resolve, reject) === pile_game.RESTORING) {}
        });
    } else {
        this.stats.cancel();
        return new Promise((resolve, reject) => step(resolve, reject));
    }
  }

  toString() {
    var s = '';
    for (var p in this.piles)
        s += this.piles[p].toString() + "\n";
    return s;
  }

  replay_url() {
    return URL.base + '?' + makeurlparams(merge(URL.param, { game:this.seed, replay:this.moves.join("") }));
  };

  // Move grammar:
  //   moves : <seed> '#' <move>*
  //   move  : <from> <to>                       # one card from top of <from> to top of <to>
  //         | <from> ':' <count> <to>           # top <count> cards of <from> to top of <to>
  //         | <from> '-' <fstart> <count> <to>  # <count> cards from middle of <from> starting at <fstart> to top of <to>
  //         | '*' <pile>                        # Clicked on pile. Game specific--usually the deck
  //         | '*[' <seed> ']'                   # Redeal
  //   from count to fstart pile: <base64-digit> # ABCDEFG...abcdefg...0123456789+/
  add_move(m) {
    if (m.internal) return; // Internal moves are part of the game mechanics and shouldn't be listed in the move list.
    var s, from = m.from, to = m.to, n = m.n, fstart = m.fstart, tstart = m.tstart;
    if (tstart !== undefined && tstart != to.pile.length)
        report_error("add_move", "add support for tstart to add_move", { m });
    if (fstart + n == from.pile.length)
        if (n == 1) s=sprintf("%s%s", from.move_char(), to.move_char());
        else        s=sprintf("%s:%s%s", from.move_char(), base64.to(n), to.move_char());
    else            s=sprintf("%s-%s%s%s", from.move_char(), base64.to(fstart), base64.to(n), to.move_char());
    this.moves.push(s);
  }

  end_of_move() {
    this.stats.set("moves", this.moves.join(""));
    super.end_of_move();
  }

  end(complete) {
    this.stats.set("score", this.score());
    super.end(complete);
  }

  schedule_update(pile) {
    if (!this.update_deferral)
        this.update_deferral = new Deferral(function() {
                for (var i in this._update.piles) {
                    this.piles[+i].fixup_coords();
                    this.piles[+i].update();
                }
                delete this._update;
        }.bind(this));

    if (!this._update)
        this._update = { piles: {} };

    this._update.piles[pile.pilenum] = true;
    this.update_deferral.defer();
  }

  do_updates() {
    this.update_deferral.run();
  }

  animate_move(m, callback, dz) {
    var count=0;
    var finished = function() { // Only call the callback when all the cards have finished animating.
        if (!count-- && callback)
            callback();
    }
    for (var t=0; t<m.length; t++)
        for (var i=0; i<m[t].n; i++)
            if (m[t].tanimate == undefined || m[t].tanimate !== false) {
                count++;
                m[t].removed[i].ui.animate_to(m[t].to, m[t].tstart+i, dz, finished);
            }

    for (var t=0; t<m.length; t++) {
        this.schedule_update(m[t].to);
        this.schedule_update(m[t].from);
    }

    finished();
  }

  do_move(m) {
    for (var t=0; t<m.length; t++) {
        if (m[t].tstart === undefined)
            m[t].tstart = m[t].to.pile.length;
        this.add_move(m[t]);
        var before = (function(pile) { return pile.name + ": " + map(function(c) { return c.toString() }, pile.pile).join(' '); })(m[t].from);
        m[t].removed = m[t].from.splice(m[t].fstart, m[t].n);
        m[t].to.splice.apply(m[t].to, [m[t].tstart , 0].concat(m[t].removed));
        if (m[t].removed.length != m[t].n)
            this.bug("do_move()", "Tried to take more cards than there were in the pile!",
                     { n: m[t].n, fstart: m[t].fstart, from: before, removed: map(function(c) { return ""+c }, m[t].removed) });
    }
    return m;
  }

  // Pile archetypes:
  _gfis_next = [hearts,clubs,spades,diamonds];
  _gfis = spades; // Foundation Icon Suit. (starts at one minus :-)
  gfis_next() {
    return this._gfis = this._gfis_next[this._gfis]
  }

  static generic_foundation = class extends pile {
      constructor(div,game,draggable) {
        super(div,game);

        this.draggable = draggable;
        this.icon = new card("F", this.game.gfis_next(), 0, up, null, game);
        this.icon.ui.draw(this.ui, { x:0, y:0, z:-1 });
      }
      icon_bonus = function(card) {
            return card.suit == this.icon.suit ? 5 : card.red == this.icon.red
      };
      accept_stacks = true;
      accept(card) {
            var tcard = card[card.length-1];
            return ((this.pile.length == 0 && tcard.rank == ace ||
                     this.pile.length      && in_suit_order(this.top(), tcard))
                    && in_order_by(in_suit_order, card) ? 10 + this.icon_bonus(tcard) : 0);
      }
      split_move(start, n, from) {
            var m=[];
            for (var i=start; i<start+n; i++)
                m.push({from:from,to:this,fstart:i,n:1});
            return m.reverse();
      }
      can_drag(index) { return this.draggable && index == this.top_index(); }
      xoffset = 0;
      yoffset = 0;
  };

  redraw() {
    for (var i in this.piles) {
        this.piles[i].redraw();
        this.piles[i].update();
    }
  }


  on_pause () {
    this.ui.on_pause();
  }

  on_unpause () {
    this.ui.on_unpause();
  }

  move_affinity(from_pile, fstart, to_pile, tstart, n) {
    if (tstart != to_pile.pile.length) { report_error("move_affinity", "implement tstart", { from_pile, fstart, to_pile, tstart, n }); return; }
    var card = from_pile.pile.slice(fstart, fstart+n);
    if (to_pile.accept_stacks)
        return to_pile.accept(card, from_pile);
    else if (card.length == 1)
        return to_pile.accept(card[0], from_pile);
  }

  find_target_piles(pile, fstart, n, other_pile) {
    var p = [];
    for (var i in this.piles) {
        var x = { pile: this.piles[i], sort: this.move_affinity(pile, fstart, this.piles[i], this.piles[i].pile.length, n) };
        if (x.pile != pile && x.pile != other_pile && x.sort)
            p.push(x);
    }
    p.sort(function(a,b) { return b.sort - a.sort });
    for (var i in p)
        p[i] = p[i].pile;
    return p;
  }
}

module.exports = {
    // Should probably be in cards.js:
    joker: joker,
    ace: ace,
    jack: jack,
    queen: queen,
    king: king,
    foundation: foundation,
    clubs: clubs,
    diamonds: diamonds,
    hearts: hearts,
    spades: spades,
    up: up,
    down: down,
    card: card,
    in_color_order: in_color_order,
    in_color_wrap_order: in_color_wrap_order,
    in_off_color_order: in_off_color_order,
    in_off_color_wrap_order: in_off_color_wrap_order,
    in_suit_order: in_suit_order,
    in_suit_wrap_order: in_suit_wrap_order,
    in_different_suit_order: in_different_suit_order,
    in_numeric_order: in_numeric_order,
    in_numeric_wrap_order: in_numeric_wrap_order,
    in_order_by: in_order_by,
    count_top_order_by: count_top_order_by,
    score_run: score_run,
    score_order_by: score_order_by,

    // Actual piles stuff:
    pile_game: pile_game,
    pile: pile,
    generic_foundation: pile_game.generic_foundation,
    drag_max_given_free: drag_max_given_free,
    empty_pile_count: empty_pile_count,
    base64: base64
};
